import { FC, ReactNode, useState } from "react";
import { Portal, formStyles } from "shared/ui";
import type { RaffleTab } from "../model/raffleTabs";
import { useRestoredRafflesTab } from "../model/useRaffleNavigation";
import { WheelRafflesModal } from "./WheelRafflesModal";

interface Props {
  className?: string;
  title?: string;
  // Содержимое кнопки: текст в Help, иконка в боковой панели.
  children?: ReactNode;
  // Открыть список при возврате со страницы промо. Только у одной кнопки
  // на дашборде, иначе откроется несколько списков.
  restoresList?: boolean;
}

const DEFAULT_CLASS = `${formStyles.outlineButton} ${formStyles.accent}`;

export const WheelRafflesButton: FC<Props> = ({
  className = DEFAULT_CLASS,
  title,
  children = "Promos",
  restoresList = false,
}) => {
  const restoredTab = useRestoredRafflesTab(restoresList);
  // null — список закрыт.
  const [listTab, setListTab] = useState<RaffleTab | null>(restoredTab);

  return (
    <>
      <button
        type="button"
        className={className}
        title={title}
        onClick={() => setListTab("raffles")}
      >
        {children}
      </button>

      <Portal>
        {listTab && (
          <WheelRafflesModal
            initialTab={listTab}
            onClose={() => setListTab(null)}
          />
        )}
      </Portal>
    </>
  );
};
